import { useEffect, useState } from "react";
import { useMediaActivityHeartbeat } from "@kaltura/mediaspace-shared-session-activity";

/**
 * Heartbeats the session activity provider while the given Kaltura Player V3
 * instance is actually playing, based on the SDK's own PLAYING/PAUSE/PLAYBACK_ENDED
 * events (read dynamically off the player, not hardcoded strings).
 */
export const usePlayerActivityHeartbeat = (player: any) => {
    const [isPlaying, setIsPlaying] = useState(false);

    useEffect(() => {
        if (!player) return;

        const { PLAYING, PAUSE, PLAYBACK_ENDED } = player.Event.Core;
        const handlePlaying = () => setIsPlaying(true);
        const handleNotPlaying = () => setIsPlaying(false);

        player.addEventListener(PLAYING, handlePlaying);
        player.addEventListener(PAUSE, handleNotPlaying);
        player.addEventListener(PLAYBACK_ENDED, handleNotPlaying);

        return () => {
            player.removeEventListener(PLAYING, handlePlaying);
            player.removeEventListener(PAUSE, handleNotPlaying);
            player.removeEventListener(PLAYBACK_ENDED, handleNotPlaying);
            setIsPlaying(false);
        };
    }, [player]);

    useMediaActivityHeartbeat(isPlaying);
};
